// extracted by mini-css-extract-plugin
export default {"tileOverlayLayer":"TileOverlayLayer_mobile_tileOverlayLayer__vRFdU"};